import { react2angular } from 'react2angular';
import {
  replaceMarkupWithTags,
  isLimitedAccessOnUnclaimedBrokerage,
} from 'utils';
import { Modal } from 'components';

import FeedbackMessageEditor from './FeedbackMessageEditor';
import { getTemplates } from '../../../../api/TemplateController';
import FeedbackSettings from './FeedbackSettings';

angular.module('bb.appointments.feedback').component('bbFeedbackSettings', {
  bindings: {},
  controller: bbFeedbackSettingsCtrl,
  controllerAs: 'vm',
  template: require('./feedback_settings.html'),
});

bbFeedbackSettingsCtrl.$inject = [
  'FeedbackService',
  'ErrorService',
  'ToastService',
  'AppointmentConfigService',
  '$routeParams',
  '$q',
  '$location',
  '$resource',
  '$scope',
  '$rootScope',
];

function bbFeedbackSettingsCtrl(
  FeedbackService,
  ErrorService,
  ToastService,
  AppointmentConfigService,
  $routeParams,
  $q,
  $location,
  $resource,
  $scope,
  $rootScope,
) {
  const vm = this;

  function getAgentsandClients(contacts) {
    return contacts
      .filter(contact =>
        ['Agent', 'Seller', 'Tenant', 'Landlord/Manager'].includes(
          contact.type,
        ),
      )
      .sort((a, b) => (a.contactId > b.contactId ? 1 : -1));
  }

  vm.$onInit = function () {
    const { listingId } = $routeParams;
    vm.listingId = listingId;
    $q.all([
      FeedbackService.getSettings(listingId),
      AppointmentConfigService.getListingAppointmentConfig(listingId),
    ])
      .then(function ([feedbackSettings, { contacts }]) {
        const { $promise, $resolved, ...parsedSettings } = feedbackSettings;
        vm.settings = parsedSettings;
        vm.template = feedbackSettings.template || [];
        vm.templateId = vm.settings.templateId;
        vm.listing = vm.settings.listing;
        vm.settings.subject =
          feedbackSettings.subject ||
          `Showing Feedback - ${vm.listing.line1} ${
            vm.listing.line2 || ''
          }`.trim();
        vm.agents = getAgentsandClients(contacts);
        vm.getEmailTemplates(listingId);
        vm.getFeedbackSurveyTemplates(listingId);
      })
      .catch(function (err) {
        const { data } = err;
        if (data.type === 'FORBIDDEN_ACTION') {
          data.message =
            'You do not have permissions to view this page. Please contact support@brokerbay.com for more information.';
        }
        ErrorService.toastyHTTPErr({ ...err, data });
        $location.path(`/listing/${vm.listingId}/view`);
      })
      .finally(function () {
        vm.dataLoaded = true;
      });
  };

  vm.showWarning = function () {
    vm.settings.collecting = !vm.settings.collecting;
    $scope.$digest();
    swal(
      {
        title: `Turning ${!vm.settings.collecting ? 'Off' : 'On'} Feedback`,
        text: `Are you sure you want to turn ${
          !vm.settings.collecting ? 'off' : 'on'
        } feedback for this listing?`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#62cb31',
        confirmButtonText: 'Confirm',
        closeButtonText: 'Cancel',
        closeOnConfirm: true,
      },
      function (confirm) {
        if (confirm) {
          vm.dataLoaded = false;
          const settings = angular.copy(vm.settings);
          if (settings.emailTemplate) {
            settings.emailTemplate = replaceMarkupWithTags(
              settings.emailTemplate,
            );
          }
          delete settings.$resolved;
          delete settings.$promise;
          FeedbackService.saveSettings(vm.listingId, settings)
            .then(function (feedbackSettings) {
              vm.settings = feedbackSettings;
              vm.templateId = vm.settings.templateId;
              ToastService.add({
                message: vm.settings.collecting
                  ? 'Feedback is now being collected'
                  : 'Feedback has been disabled',
                type: 'success',
              });
            })
            .catch(function (err) {
              ErrorService.toastyHTTPErr(err);
            })
            .finally(function () {
              vm.dataLoaded = true;
            });
        } else {
          vm.settings.collecting = !vm.settings.collecting;
          $scope.$digest();
        }
      },
    );
  };

  vm.saveSettings = function () {
    vm.dataLoaded = false;
    vm.settings.template = vm.template;
    const settingsToSave = {
      ...vm.settings,
      emailTemplate: replaceMarkupWithTags(vm.settings.emailTemplate),
      templateId: vm.settings.templateId,
      surveyTemplateId: vm.settings.surveyTemplateId,
      subject: vm.settings.subject || '',
    };
    delete settingsToSave.$resolved;
    delete settingsToSave.$promise;
    FeedbackService.saveSettings(vm.listingId, settingsToSave)
      .then(function (feedbackSettings) {
        vm.settings = feedbackSettings;
        ToastService.add({
          message: 'Feedback Settings have been saved',
          type: 'success',
        });
        vm.isCustomSelected = false;
        $location.path(vm.redirect(vm.listingId));
      })
      .catch(function (err) {
        ErrorService.toastyHTTPErr(err);
        vm.dataLoaded = true;
      });
  };

  vm.updateTemplate = function (template) {
    vm.template = template;
  };

  vm.updateContacts = function (contact) {
    if (!contact.email && contact.type !== 'Agent') {
      return;
    }
    contact.listingId = vm.listingId;
    vm.agents = null;
    contact.rep = contact.contactId;
    AppointmentConfigService.saveConfigContact(contact)
      .then(function ({ updatedContacts }) {
        vm.agents = getAgentsandClients(updatedContacts);
      })
      .catch(function (err) {
        ErrorService.toastyHTTPErr(err);
      })
      .finally(function () {
        vm.dataLoaded = true;
      });
  };

  vm.signature = '';
  vm.emailTemplates = [];
  vm.emailTemplateLoaded = false;
  vm.setSubject = value => {
    if (!vm.settings) return;
    vm.settings.subject = value;
  };
  vm.setEmailBody = value => {
    if (!vm.settings) return;
    vm.settings.emailTemplate = replaceMarkupWithTags(value);
  };
  vm.setTemplateId = id => {
    if (!vm.settings) return;
    vm.settings.templateId = id;
  };
  vm.setSurveyTemplateId = id => {
    if (!vm.settings) return;
    vm.settings.surveyTemplateId = id;
    setTimeout(() => {
      $scope.$digest();
    }, 0);
  };

  vm.getEmailTemplates = listingId => {
    $q.all([
      FeedbackService.getFeedbackTemplates(listingId),
      FeedbackService.getRepsSignatures(listingId),
    ]).then(([templates, { signature }]) => {
      vm.signature = signature;
      const templatesWithSignature = templates.map(template => ({
        ...template,
        body: template.body.concat(signature),
      }));

      vm.emailTemplates = templatesWithSignature.filter(t => !!t);
      const defaults = vm.emailTemplates.filter(t => t.isDefault);
      const userDefault = defaults.find(t => !!t.user);
      const teamDefault = defaults.find(t => !!t.team);
      const branchDefault = defaults.find(t => !!t.location);
      const globalDefault = defaults[0];
      const defaultTemplate =
        userDefault || teamDefault || branchDefault || globalDefault;

      if (
        (!vm.settings || !vm.settings.emailTemplate) &&
        defaultTemplate?.body
      ) {
        vm.setEmailBody(defaultTemplate?.body);
      }
      vm.emailTemplateLoaded = true;
    });
  };

  vm.getFeedbackSurveyTemplates = async listingId => {
    vm.surveyTemplates = await getTemplates(listingId, 'feedbackSurvey');
    $scope.$digest();
  };

  vm.redirect = listingId => `listing/${listingId}/showings`;

  vm.isCustomSelected = false;
  vm.setIsCustomSelected = isCustomSelected => {
    vm.isCustomSelected = isCustomSelected;
  };

  vm.pathname = '';

  vm.navigateToPath = () => {
    vm.isCustomSelected = false;
    $rootScope.$apply(() => {
      $location.path(vm.pathname);
    });
  };

  vm.hasLimitedAccess = () =>
    isLimitedAccessOnUnclaimedBrokerage(
      $rootScope.auth,
      $rootScope.orgStatus,
      $rootScope.currentPlan,
    );

  $rootScope.$on('$locationChangeStart', (event, next) => {
    if (vm.isCustomSelected) {
      event.preventDefault();
      vm.pathname = next.substring(next.indexOf('#') + 1);
      Modal.confirm({
        title: 'Are you sure you want to leave?',
        okText: 'Continue',
        cancelText: 'Cancel',
        onOk: () => {
          vm.isCustomSelected = false;
          vm.navigateToPath();
        },
        content:
          'Your custom template will not be saved and you will lose any progress made.',
      });
    }
  });
}

angular
  .module('bb.appointments.feedback')
  .component(
    'feedbackMessageEditor',
    react2angular(FeedbackMessageEditor, [
      'templates',
      'templateId',
      'subject',
      'body',
      'signature',
      'setSubject',
      'setBody',
      'setTemplateId',
      'settingsId',
      'dataCy',
    ]),
  )
  .component(
    'feedbackSettings',
    react2angular(FeedbackSettings, [
      'updateTemplate',
      'template',
      'emailTemplateLoaded',
      'subject',
      'body',
      'setBody',
      'setSubject',
      'setTemplateId',
      'setSurveyTemplateId',
      'templates',
      'surveyTemplates',
      'templateId',
      'signature',
      'settingsId',
      'updateContacts',
      'contacts',
      'surveyTemplateId',
      'listing',
      'showWarning',
      'feedbackCollecting',
      'saveSettings',
      'hasLimitedAccess',
      'setIsCustomSelected',
    ]),
  );
